import UserRandomDto from "../../../../../../dto/UserRandomDto"

export enum ActionType {
    MOSHAVERAN_LOAGING = 'MOSHAVERAN_LOAGING',
    MOSHAVERAN_DATA = 'MOSHAVERAN_DATA',
    MOSHAVERAN_ERROR = 'MOSHAVERAN_ERROR'

}

export interface ActionMoshaveran {
    type: ActionType.MOSHAVERAN_DATA,
    data: UserRandomDto []
}

export interface ActionMoshaveranFetchError {
    type: ActionType.MOSHAVERAN_ERROR,
    message: String
}


type Action = ActionMoshaveran | ActionMoshaveranFetchError

export default Action